export default __webpack_public_path__ + "media/zurb/img/services/services/web-portal-img-712f1c699a10443c61c11ff089c70374.png";